import { all } from "redux-saga/effects";
import authSaga from "./auth/saga";
import mainSaga from "./Main/saga";

export default function* rootSaga(getState) {
  yield all([authSaga(), mainSaga()]);
}
